  <div [formGroup]="booleanFieldForm" class="row mt-3">
    <div class=" {{fromQuickCall ? 'col-xl-2 col-lg-2 col-md-4 col-sm-12 col-12' :'col-md-4 col-lg-4 col-xl-4'}} label_disp">
      <label class="label" for="{{ fieldId }}">
        {{ displayName }}:
        <span *ngIf="required" id="mandatory_field">&#42;</span>
      </label>
    </div>

    <div *ngIf="valueType === 1" class="{{fromQuickCall ? 'pl-3 col-xl-3 col-lg-3 col-md-7 col-sm-12 col-12'  :'col-md-7 col-lg-6 col-xl-6 col-10'}} sd_custom_input">
      <input type="radio" value="1" formControlName="data" [checked]="defaultValue === '1'">&nbsp; {{ 'CustomField.true' | translate }}&nbsp;&nbsp;
      <input type="radio" value="0" formControlName="data" [checked]="defaultValue === '0'">&nbsp; {{ 'CustomField.false' | translate }}
      <div *ngIf="booleanFieldForm.controls['data'].touched && booleanFieldForm.controls['data'].errors?.required" class="validation-error-inline text-danger">
        <div class="offset-2">
          {{ displayName }} {{ 'CustomField.fieldRequired' | translate }}
        </div>
      </div>
    </div>

    <div *ngIf="valueType === 0" class="{{fromQuickCall ? 'pl-3 col-xl-3 col-lg-3 col-md-7 col-sm-12 col-12'  :'col-md-3 col-lg-6 col-xl-6 col-10'}} sd_custom_input">
      <input type="radio" value="1" formControlName="data" [checked]="defaultValue === '1'">&nbsp; {{ 'CustomField.yes' | translate }}&nbsp;&nbsp;
      <input type="radio" value="0" formControlName="data" [checked]="defaultValue === '0'">&nbsp; {{ 'CustomField.no' | translate }}
      <div *ngIf="booleanFieldForm.controls['data'].touched && booleanFieldForm.controls['data'].errors?.required" class="validation-error-inline text-danger">
        <div class="offset-2">
          {{ displayName }} {{ 'CustomField.fieldRequired' | translate }}
        </div>
      </div>
    </div>

    <span *ngIf="dscEnable === 1" [attr.data-toggle]="fieldId" data-trigger="hover" [attr.data-content]="description" class="custom_align_desc_icon">
        <em class="fa fa-question-circle fa-lg"></em>
    </span>
  </div>
